module.exports = __webpack_public_path__ + "static/video2-67b437102a4c918ae652cf4c15d81d57.mp4";